
( function () {
    'use strict';
    const searchTrigger = document.querySelector('.search-trigger');
    const searchField = document.querySelector('.search-field');
    const containerLocationService = document.querySelector('.container-location-service');
    const containerUtilityNav = document.querySelector('.container-utility-menu');
    const utilityMenuNav = document.getElementById('menu-utility-menu');
    const btnCancel = document.querySelector('.btn-cancel-search');
    const searchInput = document.getElementById('global-search-input');
    const btnSearch = searchField.getElementsByTagName('button')[0];
    const screen = document.querySelector('.screen');
    const url = document.location.href;
    let isSubSite = false;

    if (url.indexOf('generation-steam') > -1 || url.indexOf('biocom-california-institute') > -1 || url.indexOf('purchasing-group') > -1 || url.indexOf('hr-conference') > -1 || url.indexOf('global-partnering-conference') > -1 ) {
        isSubSite = true;
    } else {
        isSubSite = false;
    }
    
    const resetSearchState = () => {
        isSubSite ? containerUtilityNav.style.background = '#ffab00' : containerUtilityNav.style.background = '#0f0f0f';
        searchTrigger.style.display = 'inline-block';
        if (containerLocationService) {
            containerLocationService.style.display = 'block';
        }
        utilityMenuNav.style.display = 'flex';
        searchField.style.display = 'none';
        searchInput.value = '';
        screen.style.display = 'none';
    };

    const bindEventListeners = () => {
        // Focus input if Searchform is empty
        [].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
            el.addEventListener( 'submit', function ( e ) {
                var search = el.querySelector( 'input' );
                if ( search.value.length < 1 ) {
                    e.preventDefault(); 
                    search.focus(); 
                    resetSearchState();
                }
            });
        });

        searchTrigger.addEventListener('click', event => {
            containerUtilityNav.style.background = '#f8f9fa';
            searchTrigger.style.display = 'none';
            if (containerLocationService) {
                containerLocationService.style.display = 'none';
            }
            utilityMenuNav.style.display = 'none';
            searchField.style.display = 'flex';
            searchInput.focus();
            screen.style.display = 'flex';
        });

        btnCancel.addEventListener('click', event => {
            resetSearchState();
        });
    };
    
    bindEventListeners();

} )(); 